import Vue from 'vue'
import App from './App.vue'

import echarts from 'echarts'

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

//引入百度统计插件
import ba from 'vue-ba'
Vue.use(ba, 'd3db21ed7b338b6b97b365817a4dd104')

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
